import React from 'react';
import { formatTime } from '../../utils/formatTime';
import type { TimerState, TimerType } from '../../types';

interface TimerDisplayProps {
  displayMs: number;
  state: TimerState;
  type: TimerType;
}

export function TimerDisplay({ displayMs, state, type }: TimerDisplayProps) {
  const isRunning = state === 'running';
  const isOvertime = type === 'countdown' && isRunning && displayMs < 0;

  return (
    <div
      className={`
        font-mono text-center select-none transition-colors duration-300
        ${isOvertime ? 'text-namm-danger' : ''}
        ${isRunning && !isOvertime ? 'text-namm-text' : ''}
        ${state === 'idle' || state === 'finished' ? 'text-namm-muted' : ''}
        ${state === 'paused' ? 'text-namm-text/60' : ''}
      `}
    >
      <div className="text-4xl sm:text-5xl font-semibold tracking-tight tabular-nums">
        {formatTime(displayMs)}
      </div>
      {isOvertime && (
        <div className="text-xs text-namm-danger mt-1 uppercase tracking-widest font-bold">
          ⚠️ Temps dépassé
        </div>
      )}
    </div>
  );
}
